<!-- @format -->
<template>
    <div class="collateral-organization-select-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Choose Collateral</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <collateral-select-display
                    multiselector
                    :initialSelectedItems="initialSelectedItems"
                    :hasCardOptions="false"
                    @select="select($event)"
                />
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn" @click="closeWidget">Cancel</app-button>
                </div>
                <div class="action-container">
                    <app-button @click="chooseCollateral()">Choose this collateral</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const CollateralSelectDisplay = () => import('@/components/collateral/collateral-select-display');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'collateral-organization-select-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'collateral-select-display': CollateralSelectDisplay,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            selectedItems: [],
            initialSelectedItems: [],
        };
    },

    created() {
        if (this.widget.initialSelectedIds) {
            this.initialSelectedItems = this.widget.initialSelectedIds.map((id) => {
                return { id: id };
            });
        }
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        select(items) {
            this.selectedItems = items;
        },

        chooseCollateral() {
            EventBus.$emit(
                'collateral:select',
                this.selectedItems.map((item) => item.id)
            );
            this.closeWidget();
        },
    },
};
</script>

<style>
.collateral-organization-select-widget .master-display .master-cards .master-card-wrapper {
    padding: 0;
}

.collateral-organization-select-widget .master-display .display-title {
    display: none;
}

.collateral-organization-select-widget .app-multiselect-new.multiselect .multiselect__tags {
    background: transparent;
    padding-left: 6px;
}

.collateral-organization-select-widget .cancel-btn {
    background: transparent;
    color: #877d88;
    border: none;
}

.collateral-organization-select-widget .cancel-btn:hover {
    background: #e1e0e5;
}

.collateral-organization-select-widget .email-template-display .master-card .title-row {
    padding-top: 10px;
}

.collateral-organization-select-widget .master-card {
    margin: 0 5px;
}

.collateral-organization-select-widget .widget-contents-container .content-wrapper {
    padding-top: 0;
}
</style>
